"use client";

import { useEffect, useState } from "react";
import { FileTextIcon } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DatePicker } from "@/components/ui/date-picker";
import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";

export interface AvsFleetAdditionalInformationsProps {
  onCanProceedChange?: (canProceed: boolean) => void;
}

export function AvsFleetAdditionalInformations({
  onCanProceedChange,
}: AvsFleetAdditionalInformationsProps) {
  const fleetDeliveryLocation = "Villers Cotterêts";
  const [intranetOrderNumber, setIntranetOrderNumber] = useState("");
  const [contractReferenceNumber, setContractReferenceNumber] = useState("");
  const [preferredDeliveryDate, setPreferredDeliveryDate] = useState("");

  useEffect(() => {
    onCanProceedChange?.(!!preferredDeliveryDate);
  }, [onCanProceedChange, preferredDeliveryDate]);

  return (
    <Card>
      <CardHeader className="space-y-3 pb-2">
        <CardTitle className="flex items-center gap-2 text-base font-semibold">
          <FileTextIcon className="text-primary h-5 w-5 shrink-0" aria-hidden />
          Informations complémentaires
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 pt-2">
        <FieldGroup className="grid gap-4 md:grid-cols-2">
          <Field>
            <FieldLabel htmlFor="fleet-intranet-order">
              N° de commande intranet
            </FieldLabel>
            <Input
              id="fleet-intranet-order"
              value={intranetOrderNumber}
              onChange={(event) => setIntranetOrderNumber(event.target.value)}
              placeholder="S000000000"
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="fleet-contract-ref">
              N° de contrat réf
            </FieldLabel>
            <Input
              id="fleet-contract-ref"
              value={contractReferenceNumber}
              onChange={(event) =>
                setContractReferenceNumber(event.target.value)
              }
              placeholder="111222"
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="fleet-preferred-delivery-date">
              Date de livraison souhaitée{" "}
              <span className="text-destructive">*</span>
            </FieldLabel>
            <DatePicker
              id="fleet-preferred-delivery-date"
              value={
                preferredDeliveryDate
                  ? new Date(preferredDeliveryDate)
                  : undefined
              }
              onChange={(date) =>
                setPreferredDeliveryDate(date?.toString() ?? "")
              }
              min={new Date()}
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="fleet-delivery-location">
              Lieu de livraison
            </FieldLabel>
            <Input
              id="fleet-delivery-location"
              value={fleetDeliveryLocation}
              readOnly
              disabled
              aria-readonly
            />
            <FieldDescription>
              Valeur imposée pour les dossiers Flotte.
            </FieldDescription>
          </Field>
        </FieldGroup>
      </CardContent>
    </Card>
  );
}
